// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".buttons-row[data-v-0c70755a]{display:flex;justify-content:center}.dx-button.dx-button-normal.dx-state-disabled[data-v-0c70755a]{background-color:#a9a9a9!important}.dx-button.dx-button-normal[data-v-0c70755a]{margin-left:1.5rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
